// extracted by mini-css-extract-plugin
export var abbr = "Markdown-module--abbr--8ecd6";
export var blockquote = "Markdown-module--blockquote--f963f";
export var cdsAssistiveText = "Markdown-module--cds--assistive-text--298f7";
export var cdsHideFeedback = "Markdown-module--cds--hide-feedback--1a6a3";
export var cdsShowFeedback = "Markdown-module--cds--show-feedback--97a9f";
export var cdsSkeleton = "Markdown-module--cds--skeleton--c2011";
export var cdsVisuallyHidden = "Markdown-module--cds--visually-hidden--80119";
export var h1 = "Markdown-module--h1--a3fa2";
export var h2 = "Markdown-module--h2--0539e";
export var h3 = "Markdown-module--h3--277e0";
export var h4 = "Markdown-module--h4--34302";
export var h5 = "Markdown-module--h5--2616c";
export var h6 = "Markdown-module--h6--d7546";
export var ordered = "Markdown-module--ordered--1ff1d";
export var paragraph = "Markdown-module--paragraph--22afb";
export var paragraphResponsive = "Markdown-module--paragraph--responsive--d5d96";
export var sup = "Markdown-module--sup--906a8";
export var unordered = "Markdown-module--unordered--4b7c5";